import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "w-full max-w-lg overflow-hidden rounded-2xl bg-white shadow-2xl" };
const _hoisted_2 = { class: "flex items-start justify-between gap-4 border-b border-ewhite-200 p-5" };
const _hoisted_3 = { class: "text-lg font-semibold leading-tight text-eblack-900" };
const _hoisted_4 = { class: "mt-1 text-sm text-eblack-500" };
const _hoisted_5 = { class: "sr-only" };
const _hoisted_6 = { class: "max-h-[60vh] overflow-y-auto p-5" };
const _hoisted_7 = {
    key: 0,
    class: "space-y-3"
};
const _hoisted_8 = {
    key: 1,
    class: "py-6 text-center text-sm text-red-500"
};
const _hoisted_9 = {
    key: 2,
    class: "flex flex-col items-center justify-center py-10 text-center"
};
const _hoisted_10 = { class: "flex h-14 w-14 items-center justify-center rounded-full bg-ewhite-100" };
const _hoisted_11 = { class: "mt-3 text-sm text-eblack-500" };
const _hoisted_12 = {
    key: 3,
    class: "space-y-2.5"
};
const _hoisted_13 = { class: "flex items-baseline justify-between gap-3" };
const _hoisted_14 = { class: "text-sm font-semibold text-eblack-900" };
const _hoisted_15 = { class: "text-sm text-eblack-500" };
const _hoisted_16 = { class: "mt-2 flex flex-wrap items-center gap-x-4 gap-y-1.5 text-[13px] text-eblack-500" };
const _hoisted_17 = { class: "font-medium text-eblack-700" };
const _hoisted_18 = { class: "inline-flex items-center gap-1" };
import { onMounted, ref } from "vue";
import { IconCalendarOff, IconUsers, IconX } from "@tabler/icons-vue";
import { useI18n } from "vue-i18n";
import { calendarRepository } from "@domains/scheduling/repositories/calendar.repository";
import { DayOfWeek } from "@/domains/shared/models/day-of-week.value-object";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ServiceScheduleModal',
    props: {
        service: {}
    },
    emits: ["close"],
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        const rules = ref([]);
        const isLoading = ref(true);
        const error = ref(false);
        function dayLabel(key) {
            return DayOfWeek.toLabel(key) ?? key;
        }
        function formatTime(value) {
            return value ? value.slice(0, 5) : value;
        }
        function formatPrice(rule) {
            const amount = Number.isInteger(rule.total_price)
                ? rule.total_price
                : rule.total_price.toFixed(2);
            const unit = rule.price_type === "HOUR"
                ? t("services.auto.por_hora")
                : t("services.auto.por_persona");
            return `$${amount} ${unit}`;
        }
        onMounted(async () => {
            if (props.service.id == null) {
                isLoading.value = false;
                return;
            }
            try {
                rules.value = await calendarRepository.getAvailabilityRules(props.service.id);
            }
            catch (err) {
                console.error(err);
                error.value = true;
            }
            finally {
                isLoading.value = false;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", null, [
                        _createElementVNode("h3", _hoisted_3, _toDisplayString(__props.service.name), 1),
                        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("services.auto.opciones_de_horario_del_servicio")), 1)
                    ]),
                    _createElementVNode("button", {
                        type: "button",
                        class: "-mr-1 -mt-1 inline-flex h-8 w-8 items-center justify-center rounded-lg text-eblack-400 hover:bg-eblack-50 hover:text-eblack-700",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close')))
                    }, [
                        _createVNode(_unref(IconX), { class: "h-4 w-4" }),
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("services.auto.cerrar")), 1)
                    ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                    (isLoading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
                                return _createElementVNode("div", {
                                    key: n,
                                    class: "h-16 w-full animate-pulse rounded-xl bg-eblack-100"
                                });
                            }), 64))
                        ]))
                        : (error.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.$t("services.auto.no_se_pudieron_cargar_los_horarios")), 1))
                            : (rules.value.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                        _createVNode(_unref(IconCalendarOff), { class: "h-7 w-7 text-eblack-300" })
                                    ]),
                                    _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("services.auto.sin_horarios_configurados")), 1)
                                ]))
                                : (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rules.value, (rule, index) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            key: rule.id ?? index,
                                            class: "rounded-xl border border-ewhite-200 p-4"
                                        }, [
                                            _createElementVNode("div", _hoisted_13, [
                                                _createElementVNode("span", _hoisted_14, _toDisplayString(dayLabel(rule.day_of_week)), 1),
                                                _createElementVNode("span", _hoisted_15, _toDisplayString(formatTime(rule.start_time)) + " – " + _toDisplayString(formatTime(rule.end_time)), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_16, [
                                                _createElementVNode("span", _hoisted_17, _toDisplayString(formatPrice(rule)), 1),
                                                _createElementVNode("span", _hoisted_18, [
                                                    _createVNode(_unref(IconUsers), { class: "h-3.5 w-3.5" }),
                                                    _createTextVNode(" " + _toDisplayString(_ctx.$t("services.auto.capacidad_maxima")) + " " + _toDisplayString(rule.standard_max_participants), 1)
                                                ]),
                                                _createElementVNode("span", {
                                                    class: _normalizeClass(["inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium", rule.allow_reservations
                                                            ? 'bg-egreen-100 text-egreen-700'
                                                            : 'bg-eblack-50 text-eblack-500'])
                                                }, [
                                                    _createElementVNode("span", {
                                                        class: _normalizeClass(["h-1.5 w-1.5 rounded-full", rule.allow_reservations ? 'bg-egreen-500' : 'bg-eblack-300'])
                                                    }, null, 2),
                                                    _createTextVNode(" " + _toDisplayString(rule.allow_reservations
                                                        ? _ctx.$t("services.auto.reservas_habilitadas")
                                                        : _ctx.$t("services.auto.reservas_deshabilitadas")), 1)
                                                ], 2)
                                            ])
                                        ]));
                                    }), 128))
                                ]))
                ])
            ]));
        };
    }
});
